import React, { useEffect, useState } from "react";
import {
  getAllWarehouseInventoryDispatch,
  getAllStoresByCountryCode,
} from "api/warehouseInventoryDispatch/warehouseInventoryDispatch";
import {
  ControlLabel,
  FormControl,
  FormGroup,
  Grid,
  Modal,
} from "react-bootstrap";
import Card from "components/Card/Card";
import ScreenLoader from "views/Components/screenLoader";
import NotificationSystem from "react-notification-system";
import Swal from "sweetalert2";
import LoadingSpinner from "views/Components/loadingSpinner";
import moment from "moment";
import { Button } from "react-bootstrap";
import Select from "react-select";
import { getAllMedicationCategory } from "api/purchaseOrder/PurchaseOrder";
import { AddMedication } from "Listfunction";

const AddMedicationModal = (props) => {
  const _notificationSystem = React.createRef();
  const token = JSON.parse(localStorage.getItem("user"));
  const obj = token.token;
  const [loading, setLoading] = useState(true);
  const [medicationCategory, setMedicationCategory] = useState([]);

  useEffect(() => {
    setLoading(false);
    getAllMedicationCategory(obj)
      .then((data) => {
        console.log("Medication Categories:", data);
        const categories = data.data.map((category) => ({
          value: category.id,
          label: category.category_name,
        }));
        setMedicationCategory(categories);
        // setMedicationCategory(data);
      })
      .catch((error) => {
        console.error("Error fetching medication categories:", error);
      });
  }, []);

  return (
    <div className="main-content">
      <NotificationSystem ref={_notificationSystem} />
      {props.isLoading && <ScreenLoader />}
      <Modal show={props.isOpen} onHide={props.onClose} size="lg">
        <Modal.Header>
          <Modal.Title>Add Medication</Modal.Title>
          <Modal.Body>
            <FormGroup>
              <ControlLabel>Medication Category</ControlLabel>
              <Select
                options={medicationCategory}
                value={props.selectedMedicationCategory}
                onChange={(selectedOption) => {
                  props.setSelectedMedicationCategory(selectedOption);
                  props.setMedicationModalCategoryError(null);
                }}
                placeholder="Select Medication Category"
              />
              {props.medicationModalCategoryError && (
                <div style={{ color: "red" }}>
                  {props.medicationModalCategoryError}
                </div>
              )}
            </FormGroup>
            <FormGroup>
              <ControlLabel>Medication Name</ControlLabel>
              <FormControl
                type="text"
                placeholder="Medication Name"
                value={props.medicationName}
                onChange={(e) => {
                  props.setMedicationName(e.target.value);
                  props.setMedicationModalNameError(null);
                }}
              />
              {props.medicationModalNameError && (
                <div style={{ color: "red" }}>
                  {props.medicationModalNameError}
                </div>
              )}
            </FormGroup>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger" onClick={props.onClose}>
              Close
            </Button>
            <Button variant="primary" onClick={props.handleAddMedication}>
              Submit
            </Button>
          </Modal.Footer>
        </Modal.Header>
      </Modal>
    </div>
  );
};
export default AddMedicationModal;
